import React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { SET_SCORE } from '../db';
import theme from '../theme';
import { IAppState } from '../db/reducers';

const SChoiceBox = styled.div`
  display: flex;
  cursor: pointer;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 1.6vh;
  margin: 0 0 1vh 0;
  border-radius: 0.8em;
  width: 60vw;
`;

const SChoiceDescription = styled.p`
  display: flex;
  margin: none;
  margin-top: 0.01vh;
  margin-bottom: 0.01vh;
  margin-block-start: 0.01vh;
  margin-block-end: 0.01vh;
  color: ${theme.textSecondary};
`;

interface IChoiceProps {
  color: string;
  description: string;
  scoreValue: string;
  setUserCurrentScore(currentScore: number): void;
}

const Choice: React.SFC<IChoiceProps> = (props) => {
    const { color, description, scoreValue, setUserCurrentScore } = props;

    const currentScore = parseInt(scoreValue, 10);

    return (
      <SChoiceBox
        className='ChoiceBox'
        onClick={() => setUserCurrentScore(currentScore)}
        style={{ backgroundColor: color }}
      >
        <SChoiceDescription
          className={"SChoiceDescription"}
          style={{
            justifyContent: 'center',
          }}
        >
          {scoreValue + ' -'} {' ' + description}
        </SChoiceDescription>
      </SChoiceBox>
    );
}

const mapStateToProps = (state: IAppState) => state

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    setUserCurrentScore: (currentUserScore: number) => {
      dispatch({ type: SET_SCORE, currentUserScore });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Choice);
